import React from "react";

const SecNav = ({ title, body }) => {
  return (
    <div className="bg-brown p-5 rounded-5 mb-4">
      <h2 className="text-center fs-30 mb-4 fw-bold">{title}</h2>
      <p className="text-center text-muted fs-16">{body}</p>
    </div>
  );
};

export default SecNav;
